import React from "react";
import ServiceSection from "../../Components/ServiceSection";

const Services = () => {
  return (
    <>
      <ServiceSection />
    </>
  );
};

export default Services;